const NCBI_ID_FIELDS = [
  'ncbiID',
  'geneNcbiID',
  'gene_ncbi_id',
  'gene_ncbi',
  'geneID',
  'geneId',
] as const;

export const NCBI_ID_COLUMN_NAMES = ['ncbiID', 'geneNcbiID', 'gene_ncbi_id'] as const;

export function isNcbiIdColumn(name: string | undefined): boolean {
  return Boolean(name && (NCBI_ID_COLUMN_NAMES as readonly string[]).includes(name));
}

function isUsableNcbiId(value: unknown): value is string | number {
  if (value == null) return false;
  const normalized = String(value).trim();
  return Boolean(normalized) && normalized !== '-' && normalized !== '0';
}

export function getRowGeneNcbiId(data: Record<string, unknown> | null | undefined): string | number | undefined {
  if (!data) return undefined;

  for (const field of NCBI_ID_FIELDS) {
    const value = data[field];
    if (isUsableNcbiId(value)) return value as string | number;
  }

  const list = data.geneNcbiIDs;
  if (Array.isArray(list)) {
    const first = list.find(isUsableNcbiId);
    if (first != null) return first as string | number;
  } else if (isUsableNcbiId(list)) {
    return list as string | number;
  }

  return undefined;
}
